import React from 'react';
import {Link} from "react-router-dom";

import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {styled} from "@mui/material";
import Typography from "@mui/material/Typography";
import useMediaQuery from '@mui/material/useMediaQuery';
import Badge from "@mui/material/Badge";

type FilterListItemProps = {
    total?: number
    icon?: any
    label?: string
    idx?: number
    currentIdx?: number
    handleFilterLists: () => void
}

const StyledLink = styled(Link)({
    textDecoration: "none",
    color: "inherit"
})

const FilterListItem: React.FC<FilterListItemProps> = ({
                                                           total = 0,
                                                           icon,
                                                           label,
                                                           idx,
                                                           currentIdx,
                                                           handleFilterLists
                                                       }) => {
    const matches = useMediaQuery('(min-width:1200px)');

    return (
        <StyledLink to="/">
            {matches ? <Button variant="text"
                     color="inherit"
                     sx={{
                         textTransform: "none",
                         display: "flex",
                         flexDirection: "column",
                         width: "100%",
                         padding: "2px 1px"
                     }}
                     onClick={handleFilterLists}>
                <Grid container
                      sx={{backgroundColor: idx === currentIdx ? "#e1f5fe" : "transparent", padding: "0px 10px"}}>
                    <Grid item xs={8} display="flex" alignItems="center">
                        {icon}
                        <Typography variant="body1">{label}</Typography>
                    </Grid>
                    <Grid item xs={4} display="flex" justifyContent="flex-end">
                        <Chip label={total}/>
                    </Grid>
                </Grid>
            </Button>:
                <Badge badgeContent={total} sx={{ "& .MuiBadge-badge": { backgroundColor: "rgba(0, 0, 0, 0.08)"}}}>
                    <Button
                        variant="text"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                        onClick={handleFilterLists}
                    >{label}</Button>
                </Badge>}
        </StyledLink>
    );
};

export default FilterListItem;